module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "foo"
  }, [_c('div', {
    staticClass: "section-top"
  }), _vm._v(" "), _c('div', {
    staticClass: "scrollmenuStart"
  }, [_c('p', {
    staticClass: "notes-p"
  }, [_vm._v(_vm._s(_vm.locale.t('label_filter_show')) + ": ")]), _vm._v(" "), _vm._l((_vm.filters), function(item) {
    return _c('span', [_c('span', {
      staticClass: "chips-group clickable",
      attrs: {
        "value": ""
      },
      on: {
        "click": function($event) {
          return _vm.clickSelect(item)
        }
      }
    }, [_c('span', {
      staticClass: "single-chip"
    }, [_c('span', {
      class: _vm.getChipClass(item)
    }, [_vm._v(_vm._s(_vm.isSelected(item) ? '✔ ' : '') + _vm._s(item.name))])])])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "wod-navigation section-top"
  }, [_c('div', {
    staticClass: "wod-arrow",
    on: {
      "click": function($event) {
        return _vm.changeDate(-1)
      }
    }
  }, [_c('i', {
    staticClass: "ti-arrow-circle-left"
  })]), _vm._v(" "), _c('p', {
    staticClass: "notes-p"
  }, [_vm._v(_vm._s(_vm.output))]), _vm._v(" "), _c('div', {
    staticClass: "wod-arrow",
    on: {
      "click": function($event) {
        return _vm.changeDate(1)
      }
    }
  }, [_c('i', {
    staticClass: "ti-arrow-circle-right"
  })])]), _vm._v(" "), (!_vm.isLoading && ((_vm.filterType === 'day' && _vm.notes.length === 0))) ? _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.notesToEdit != null ? _vm.locale.t('label_user_note_edit') : _vm.locale.t('label_user_note_add')) + " ")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newNotes),
      expression: "newNotes"
    }],
    staticClass: "textarea-full",
    attrs: {
      "rows": "10"
    },
    domProps: {
      "value": (_vm.newNotes)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newNotes = $event.target.value
      }
    }
  })])])]), _vm._v(" "), (!_vm.isLoadingSave) ? _c('div', {
    staticClass: "new-button",
    on: {
      "click": _vm.saveNewNotes
    }
  }, [_c('i', {
    staticClass: "ti-save"
  }), _vm._v(" " + _vm._s(_vm.locale.t("label_save")) + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.isLoadingSave) ? _c('my-loader', {
    staticClass: "centered-div"
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (!_vm.isLoading && _vm.notes.length > 0) ? _c('div', [_c('div', {
    staticClass: "wod-container"
  }, _vm._l((_vm.notes), function(item) {
    return _c('div', {
      staticClass: "term-item section-top-sm"
    }, [(_vm.notesToEdit == null || _vm.notesToEdit.id !== item.id) ? _c('div', [_c('p', {
      staticClass: "notes-subitem"
    }, [_vm._v(_vm._s(_vm.getDayFromDate(item.date)) + " - " + _vm._s(item.date))]), _vm._v(" "), _c('p', {
      staticClass: "term-subitem-medium note-text"
    }, [_vm._v(_vm._s(item.notes))]), _vm._v(" "), _c('div', {
      staticClass: "flex-container section-top-sm"
    }, [_c('div', {
      staticClass: "new-button term-subitem-small",
      on: {
        "click": function($event) {
          return _vm.editItem(item)
        }
      }
    }, [_c('i', {
      staticClass: "ti-pencil"
    }), _vm._v(" " + _vm._s(_vm.locale.t('label_edit')) + "\n            ")]), _vm._v(" "), _c('div', {
      staticClass: "new-button term-subitem-small",
      on: {
        "click": function($event) {
          return _vm.deleteItem(item)
        }
      }
    }, [_c('i', {
      staticClass: "ti-trash"
    }), _vm._v(" " + _vm._s(_vm.locale.t('label_delete')) + "\n            ")])])]) : _vm._e(), _vm._v(" "), (_vm.notesToEdit != null && _vm.notesToEdit.id === item.id) ? _c('div', {
      staticClass: "row note-edit-row"
    }, [_c('p', {
      staticClass: "term-subitem-medium note-text"
    }, [_vm._v(_vm._s(_vm.getDayFromDate(item.date)) + " - " + _vm._s(item.date))]), _vm._v(" "), _c('div', {
      staticClass: "col-md-12"
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('label', {
      staticClass: "form-label"
    }, [_vm._v(_vm._s(_vm.notesToEdit != null ? _vm.locale.t('label_user_note_edit') : _vm.locale.t('label_user_note_add')) + " ")]), _vm._v(" "), _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.newNotes),
        expression: "newNotes"
      }],
      staticClass: "textarea-full",
      attrs: {
        "rows": "10"
      },
      domProps: {
        "value": (_vm.newNotes)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.newNotes = $event.target.value
        }
      }
    })])]), _vm._v(" "), (_vm.notesToEdit != null && _vm.notesToEdit.id === item.id) ? _c('div', {
      staticClass: "flex-container section-top-sm"
    }, [(!_vm.isLoadingSave) ? _c('div', {
      staticClass: "new-button",
      on: {
        "click": _vm.saveNewNotes
      }
    }, [_c('i', {
      staticClass: "ti-save"
    }), _vm._v(" " + _vm._s(_vm.locale.t("label_save")) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.isLoadingSave) ? _c('my-loader', {
      staticClass: "centered-div"
    }) : _vm._e()], 1) : _vm._e()]) : _vm._e()])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.isLoading) ? _c('div', {
    staticClass: "center-wrapper"
  }, [_c('my-loader', {
    staticClass: "centered-div"
  })], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-49715dd8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TrainingNotes/TrainingNotes.vue
// module id = 775
// module chunks = 0